var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ccontainer"},[_c('div',{staticClass:"prejoin-preview-dropdown-container"},[_c('div',{staticClass:"css-1hbmoh1-actionButton secondary",attrs:{"aria-label":"Comprar 1 minuto extra","role":"button","tabindex":"0"},on:{"click":_vm.toggle}},[_vm._v("\n      "+_vm._s(_vm.$t("videocall.button.tokens_history"))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }